import React from "react";
import {
  Badge,
  Button,
  ComponentMultiStyleConfig,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../lib/styles/props/component-style-props";

export type CMTabMainMenuProps = {
  labelName?: string;

  badgeText?: string;

  /**
   * バッジの色
   * chakra-uiのtheme.colorsに存在する色を指定可能
   */
  badgeColor?: string;

  /**
   * バッジのスタイル設定に使用
   */
  variant?: "subtle" | "solid" | "outline";
  onClick: () => void;
} & ComponentStyleProps;

/**
 * メインメニューのタブを表示するコンポーネント
 */
export const CMTabMainMenu = ({
  labelName,
  badgeText,
  badgeColor,
  variant = "solid",
  onClick,

  sx,
  ...rest
}: CMTabMainMenuProps) => {
  const styles = useMultiStyleConfig("CMTabMainMenuStyles");

  return (
    <Button onClick={onClick} sx={{ ...styles.button, ...sx }} {...rest}>
      <Text sx={styles.text}>{labelName}</Text>
      {badgeText ? (
        <Badge backgroundColor={badgeColor} variant={variant} sx={styles.badge}>
          {badgeText}
        </Badge>
      ) : undefined}
    </Button>
  );
};

export const CMTabMainMenuStyles: ComponentMultiStyleConfig = {
  parts: ["button", "text", "badge"],
  baseStyle: {
    button: {
      bg: "whiteAlpha.700",
      display: "flex",
      gap: "4px",
      alignItems: "center",
      justifyContent: "center",
      border: "solid 1px",
      borderColor: "gray.400",
    },
    text: {
      fontWeight: "400",
      fontSize: "16px",
      lineHeight: "24px",
      color: "gray.600",
    },
    badge: {
      minW: "19px",
      minH: "19px",
      borderRadius: "50%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
  },
};
